import React from 'react';
import { Button, Form, Icon, Input, Select } from 'antd';
import InfoBox from '../../../components/InfoBox/InfoBox';
import OnboardingOptionalStepNotice from './OnboardingOptionalStepNotice';
import { ORG_ONBOARDING_INFO_COLOR } from '../onboardingConstants';

const FormItem = Form.Item;
const { Option } = Select;

export default function PlanStep({
  form,
  initialValues,
  currencies,
  isSubmitting,
  showSkip = false,
  onBack,
  onSkip,
  onContinue,
}) {
  const { getFieldDecorator, getFieldValue } = form;
  const planName = getFieldValue('name') || initialValues.name;
  const currency = getFieldValue('currency') || initialValues.currency;

  return (
    <div className="onboarding-registration-panel-body">
      <div className="onboarding-registration-panel-main">
        {showSkip ? (
          <OnboardingOptionalStepNotice
            tone="plan"
            message="This step is optional. Complete it now or use Skip for now below."
          />
        ) : null}

        <FormItem label="Plan name">
          {getFieldDecorator('name', {
            initialValue: initialValues.name,
            rules: [{ required: true, whitespace: true, message: 'Please enter a plan name.' }],
          })(<Input disabled={isSubmitting} />)}
        </FormItem>
        <p className="onboarding-registration-field-help">
          This will be the name of your continuity management plan
        </p>

        <FormItem label="Currency">
          {getFieldDecorator('currency', {
            initialValue: initialValues.currency,
            rules: [{ required: true, message: 'Please select a currency.' }],
          })(
            <Select placeholder="Select currency" disabled={isSubmitting}>
              {currencies.map((currencyOption) => (
                <Option key={currencyOption.value} value={currencyOption.value}>
                  {currencyOption.label}
                </Option>
              ))}
            </Select>,
          )}
        </FormItem>
        <p className="onboarding-registration-field-help">
          Used for money values in this plan (e.g. asset costs and risk estimates). Choose the currency your
          organisation works in — this is not a billing or payment setting.
        </p>

        <InfoBox
          className="onboarding-registration-plan-summary"
          color={ORG_ONBOARDING_INFO_COLOR}
          honorSectionGuidanceToggle={false}
          message={
            <div>
              <div>
                <strong>Plan:</strong> {planName || 'Not set'}
              </div>
              <div>
                <strong>Currency:</strong> {currency || 'Not set'}
              </div>
            </div>
          }
        />
      </div>

      <div className="onboarding-registration-actions onboarding-registration-actions-between onboarding-registration-actions-bar">
        <Button htmlType="button" onClick={onBack} disabled={isSubmitting}>
          Back
        </Button>
        <div className="onboarding-registration-actions-primary-group">
          {showSkip ? (
            <Button
              type="link"
              className="onboarding-registration-skip-link"
              htmlType="button"
              onClick={onSkip}
              disabled={isSubmitting}
            >
              Skip for now
            </Button>
          ) : null}
          <Button type="primary" htmlType="button" loading={isSubmitting} onClick={onContinue}>
            Continue <Icon type="arrow-right" />
          </Button>
        </div>
      </div>
    </div>
  );
}
